import React from "react";
import Headers from "../../Components/Headers";

function Bibilo() {
  return (
    <div className="custom-section">
      <Headers/>
     <div className="comingsoon-content">
        <h1 className="comingsoon-title">Coming Soon</h1>

        <p className="comingsoon-subtitle">
          We're building something beautiful for you.  
          Stay tuned for updates.
        </p>

        <div className="comingsoon-loader"></div>
      </div>    </div>
  );
}

export default Bibilo;
